import { EventEmitter, Injectable, Output } from "@angular/core";
import { SettlementPackFilter } from "app/module-file/domain/Process/settlement-pack/settlement-pack-filter";

@Injectable({
    providedIn: 'root'
})

export class MessagesNotification {

    @Output() Application: EventEmitter<string> = new EventEmitter();

}
